import { z } from "zod";

/** Shared by the Jyotish portal + shop kundli products. */
export const birthDetailsSchema = z.object({
  fullName: z.string().min(2, "Name is required"),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "YYYY-MM-DD"),
  time: z.string().regex(/^\d{2}:\d{2}$/, "HH:mm"),
  latitude: z.number().min(-90).max(90),
  longitude: z.number().min(-180).max(180),
  timezone: z.string().min(1),
});
export type BirthDetailsInput = z.infer<typeof birthDetailsSchema>;
